import moment from 'moment'
// 年-月-日
export function formatDate (value) {
  return moment(value).format('YYYY-MM-DD')
}

// 电话号码中间四位用省略号代替
export function telEllipsis (value) {
  let str = ''
  let tel = value + ''
  str = tel.slice(0, 3) + '****' + tel.slice(7, 11)
  return str
}

// 年-月-日  时:分:秒
// 可以修改为你需要的 时间表现样式
export function time (val) {
  var date = new Date(Number(val))
  var year = date.getFullYear()
  var month = date.getMonth() + 1 // js从0开始取
  var date1 = date.getDate()
  var hour = date.getHours()
  var minutes = date.getMinutes()
  var second = date.getSeconds()

  if ((month + '').length === 1) {
    month = '0' + month
  }
  if ((date1 + '').length === 1) {
    date1 = '0' + date1
  }
  if ((hour + '').length === 1) {
    hour = '0' + hour
  }
  if ((minutes + '').length === 1) {
    minutes = '0' + minutes
  }
  if ((second + '').length === 1) {
    second = '0' + second
  }
  return (year + '-' + month + '-' + date1 + ' ' + hour + ' : ' + minutes + ' : ' + second + '')
}
